import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export default function CompetitionPicker({ value, onChange, withAll = false }) {
  const [comps, setComps] = useState([]);
  useEffect(() => { http.get("/public/competitions").then((r) => setComps(r.data)); }, []);

  return (
    <div data-testid="competition-picker" className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
      {(withAll ? [{ code: "ALL", name: "Tutte le competizioni" }, ...comps] : comps).map((c) => (
        <button
          key={c.code}
          data-testid={`competition-${c.code}`}
          onClick={() => onChange(c)}
          className={`shrink-0 flex items-center gap-2 px-3 py-2 rounded-lg border text-sm font-medium transition-colors duration-200 ${
            value.code === c.code ? "border-[var(--gold)] bg-slate-900 text-white" : "border-slate-800 text-slate-400 hover:text-white hover:border-slate-600"
          }`}
        >
          {c.emblem && <span className="w-6 h-6 rounded bg-white/90 grid place-items-center p-0.5"><img src={c.emblem} alt="" className="max-w-full max-h-full object-contain" /></span>}
          <span className="whitespace-nowrap">{c.name}</span>
        </button>
      ))}
    </div>
  );
}
